import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationContextResolver } from 'gain-web/lib/application-context/application-context.resolver';
import { CountryRegionDataService } from 'gain-web/shared-modules/country-region-data/country-region-data.service';
import { UserContextResolver } from 'gain-web/shared-modules/user/user-context.resolver';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { PortalAuthGuard } from './portal-auth.guard';
import { UnauthorizedPageComponent } from './unauthorized-page/unauthorized-page.component';
const routes: Routes = [
  // Recovery routes live OUTSIDE the authenticated root route below so they
  // carry neither PortalAuthGuard nor the three data resolvers. The
  // navigation-error safety net (AppComponent.recoverFromFailedNavigation)
  // routes here when a root resolver throws for a NON-auth reason (e.g. a BFF
  // 500); if these pages re-ran those same resolvers the recovery navigation
  // would fail too and loop (bug 7719533). They must be declared before the
  // '' prefix route so they match first.
  {
    path: 'unauthorized',
    component: UnauthorizedPageComponent,
  },
  {
    path: 'not-found',
    component: NotFoundPageComponent,
  },
  {
    title: 'GAIN 3.0',
    path: '',
    canActivate: [PortalAuthGuard],
    resolve: {
      countryData: CountryRegionDataService,
      userContext: UserContextResolver,
      appContext: ApplicationContextResolver,
    },
    children: [
      {
        path: '',
        redirectTo: '/clients',
        pathMatch: 'full',
      },
      {
        path: 'clients',
        data: {
          level: 1,
        },
        loadChildren: () =>
          import('./clients/clients.module').then((m) => m.ClientsModule),
      },
      {
        path: 'support',
        data: {
          level: 1,
        },
        loadChildren: () =>
          import('./support/support.module').then((m) => m.SupportModule),
      },
      {
        path: 'uiux',
        loadChildren: () =>
          import('./ui-ux/uiux.module').then((m) => m.UiuxModule),
      },
      {
        path: '**',
        component: NotFoundPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
